import { logAndToast } from './logAndToast';
import { type LogHelper, LogLevels } from '@types';
import { writeIntoLogs } from '@lib/logger/writeIntoLogs.ts';

export const logSuccess: LogHelper = async (
  message,
  source,
  context,
  showToast = true,
  forceLog = false
): Promise<void> => {
  await logAndToast({
    message,
    source,
    context,
    toast: showToast,
    level: 'success',
    forceLog
  });
};

export async function writeSuccessLog<T> (message: string, source: string, context: Record<string, T>): Promise<void> {
  await writeIntoLogs({
    message,
    level: LogLevels.SUCCESS,
    source,
    context
  });
}